module.exports = __webpack_public_path__ + "static/media/ic_template_17.d3f42e6f.png";